import React from "react";
import PropTypes from "prop-types";

import { FormField, SelectFormField } from "../../../../../utils/FormFields";
import { getLocalDate } from "../../../../../utils/dateUtils";

function PersonKYC({ person, changedPerson, ...props }) {
  const { showChanges } = props;
  changedPerson = showChanges ? changedPerson : undefined;
  const showPerson = changedPerson || person;
  const emptyDate = new Date(0);
  return (
    <React.Fragment>
      <FormField label="Type: " value={person.PersonType} name="PersonType" />
      {showPerson.KYC.KYCDate !== undefined && (
        <FormField
          label="KYC Advisor Date: "
          value={showPerson.KYC.KYCDate}
          name="KYCDate"
          changedColor={changedPerson}
        />
      )}
      {showPerson.KYC.KYCReason !== undefined && (
        <FormField
          label="KYC Advisor Reason: "
          value={showPerson.KYC.KYCReason}
          name="KYCReason"
          changedColor={changedPerson}
        />
      )}
      {showPerson.KYC.KYCAdvisorComments !== undefined && (
        <FormField
          label="KYC Advisor commment: "
          value={showPerson.KYC.KYCAdvisorComments}
          name="KYCAdvisorComments"
          changedColor={changedPerson}
        />
      )}
    </React.Fragment>
  );
}

PersonKYC.propTypes = {
  person: PropTypes.object.isRequired,
  changedPerson: PropTypes.object,
};

PersonKYC.defaultProps = {
  changedPerson: undefined,
};

export default PersonKYC;
